import { importLibrary, setOptions } from '@googlemaps/js-api-loader';
import googleApiKeyLookup from './googleAPiKeyLookup';

let configuredApiKey = '';
let placesLibraryPromise = null;

const resolveApiKey = (overrideKey) => overrideKey || googleApiKeyLookup();

export async function loadPlacesLibrary(overrideKey) {
  const apiKey = resolveApiKey(overrideKey);

  if (!apiKey) {
    throw new Error('Missing Google Maps API key');
  }

  if (!configuredApiKey) {
    setOptions({
      key: apiKey,
      v: 'weekly',
      authReferrerPolicy: 'origin',
    });
    configuredApiKey = apiKey;
  } else if (configuredApiKey !== apiKey) {
    console.warn('Google Maps API key changed after loader initialization; reusing initial key.');
  }

  if (!placesLibraryPromise) {
    placesLibraryPromise = importLibrary('places');
  }

  return placesLibraryPromise;
}
